export default __webpack_public_path__ + "static/media/Logo_Codenames_White.841993c2.png";